import { statuses } from "@/crm/config";

export function toDateInput(value) {
  return new Date(value).toISOString().slice(0, 10);
}

export function addDays(value, days) {
  const date = new Date(`${value}T12:00:00`);
  date.setDate(date.getDate() + days);
  return toDateInput(date);
}

export function startOfWeek(value) {
  const date = new Date(`${value}T12:00:00`);
  const day = date.getDay();
  date.setDate(date.getDate() - day);
  return toDateInput(date);
}

export function monthDays(value) {
  const base = new Date(`${value}T12:00:00`);
  const first = new Date(base.getFullYear(), base.getMonth(), 1, 12);
  const last = new Date(base.getFullYear(), base.getMonth() + 1, 0, 12);
  const days = [];
  for (let day = 1; day <= last.getDate(); day += 1) days.push(toDateInput(new Date(base.getFullYear(), base.getMonth(), day, 12)));
  return { monthLabel: first.toLocaleDateString([], { month: "long", year: "numeric" }), days };
}

export function appointmentDate(appointment) {
  return appointment.scheduled_at?.slice(0, 10);
}

export function appointmentHour(appointment) {
  return new Date(appointment.scheduled_at).getHours();
}

export function isActiveAppointment(appointment) {
  return !["Cancelled", "No Show"].includes(appointment.status);
}

export function groupAppointmentsByStatus(appointments) {
  return statuses.reduce((acc, status) => ({ ...acc, [status]: appointments.filter((appointment) => appointment.status === status) }), {});
}

export function filterAppointmentsForCalendar(appointments, calendarView, selectedDate) {
  const activeAppointments = appointments.filter(isActiveAppointment);
  if (calendarView === "day") return activeAppointments.filter((appointment) => appointmentDate(appointment) === selectedDate);
  if (calendarView === "week") {
    const weekStart = startOfWeek(selectedDate);
    const weekEnd = addDays(weekStart, 7);
    return activeAppointments.filter((appointment) => appointmentDate(appointment) >= weekStart && appointmentDate(appointment) < weekEnd);
  }
  return activeAppointments.filter((appointment) => appointmentDate(appointment)?.slice(0, 7) === selectedDate.slice(0, 7));
}

export function calculateCalendarStats(appointments) {
  return { total: appointments.length, confirmed: appointments.filter((appointment) => appointment.status === "Confirmed").length, waiting: appointments.filter((appointment) => appointment.status === "New").length };
}
